import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Redeem from "./components/seven_knight/redeem";
import Layout from "./components/layout/Layout";

import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/seven-knight/redeem" element={<Redeem />} />
          <Route path="/" element={<Navigate to="/seven-knight/redeem" replace />} />
          <Route path="*" element={<Navigate to="/seven-knight/redeem" replace />} />
        </Routes>
      </Layout>

      <ToastContainer position="top-right" autoClose={2500} />
    </BrowserRouter>
  );
}

export default App;
